/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { speak } from '../actions';

const ProgressBar = (props) => {
  return (
    <div className="progress-bar-container">
      <p onClick={props.speak} className={`${props.speechEnabled && 'bolded'}`}>{Math.round((props.numCompleted / props.numQuestions) * 100)}% Closer To Your Toolkit</p>
      <div className="progress-bar">
        <div
          className="progress-bar-filled"
          style={{ width: `${Math.round((props.numCompleted / props.numQuestions) * 100)}vw` }}
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => (
  {
    speechEnabled: state.speech.enabled,
  }
);
export default connect(mapStateToProps, { speak })(ProgressBar);
